import {formatDate} from '../../../helpers/utils';

export const COMMON_REQ = 'cris/bin/COMMON_REQ';
export const COMMON_REQ_FAIL = 'cris/bin/COMMON_REQ_FAIL';

export const LOAD_BINS_SUCCESS = 'cris/bin/LOAD_BINS_SUCCESS';
export const LOAD_BIN_PARTS_SUCCESS = 'cris/bin/LOAD_BIN_PARTS_SUCCESS';

const initialState = {
	isLoading: false,
	error: null,
	bins: [],
	binScans: [],
	bin: null
};

export default (state = initialState, action) => {
	switch (action.type) {
		case COMMON_REQ:
			return {
				...state,
				isLoading: true
			};

		case COMMON_REQ_FAIL:
			return {
				...state,
				isLoading: false,
				error: action.error
			};

		case LOAD_BINS_SUCCESS:
			const bins = action.payload.data.bins.map((item) => ({
				id: item.id,
				business_unit_id: item.business_unit_id,
				part_library_id: item.part_library_id,
				bin_number: item.bin_number,
				source_bin_number: item.source_bin_number,
				part_number: item.part_number,
				key_code: item.key_code,
				key_code_start_position: item.key_code_start_position,
				target_count: item.target_count,
				matched_count: item.matched_count,
				scanned_count: item.scanned_count,
				status: item.status,
				comment: item.comment || '',
				is_closed: item.is_closed,
				isClosedText: item.is_closed ? 'Yes' : 'No',
				is_finalized: item.is_finalized,
				isFinalizedText: item.is_finalized ? 'Yes' : 'No',
				businessUnitName: item.business_unit.name
			}));

			return {
				...state,
				isLoading: false,
				bins: bins
			};

		case LOAD_BIN_PARTS_SUCCESS:
			const bin_scans = action.payload.data.bin_scans.map((item) => ({
				id: item.id,
				bin_id: item.bin_id,
				bin_number: item.bin ? item.bin.bin_number : '',
				scanned_number: item.scanned_number,
				is_matched: item.is_matched,
				scanned_by: item.scanned_by,
				scanned_at: item.scanned_at,
				scannedBy: item.user ? item.user.name : '',
				formattedScannedAt: item.scanned_at ? formatDate(item.scanned_at, 'MMM D, YYYY HH:mm:ss') : ''
			}));

			const bin = action.payload.data.bin;

			return {
				...state,
				isLoading: false,
				binScans: bin_scans,
				bin: bin
			};

		default:
			return state;
	}
}
